export default __webpack_public_path__ + "static/media/figma_file_icon.e44e4757.svg";